import _ from 'lodash'

const uniqueMergeArray = (array1: Array<any>, array2: Array<any>, key: any) => {
  return _.values(_.merge(_.keyBy(array1, key), _.keyBy(array2, key)))
}

export default uniqueMergeArray
